// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The markdown editor renders visible text beneath a transparent typing layer. */
.signup-spouse-editor.w-md-editor {
    color-scheme: light;
    --color-fg-default: #111827;
    --color-canvas-default: #ffffff;
    --md-editor-background-color: #ffffff;
    color: #111827;
    background-color: #ffffff;
}
.signup-spouse-editor.w-md-editor .w-md-editor-text-pre,
.signup-spouse-editor.w-md-editor .w-md-editor-text-pre > code {
    color: #111827 !important;
}
/* Override branded form textarea styling without covering the text underneath. */
.signup-spouse-editor.w-md-editor textarea.w-md-editor-text-input {
    background: transparent !important;
    color: #111827 !important;
    caret-color: #111827 !important;
    -webkit-text-fill-color: transparent !important;
    padding: inherit !important;
    margin: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    min-height: 0 !important;
    max-height: none !important;
}
`, "",{"version":3,"sources":["webpack://./components/SignupSpouseEditor.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,+BAA+B;IAC/B,qCAAqC;IACrC,cAAc;IACd,yBAAyB;AAC7B;AACA;;IAEI,yBAAyB;AAC7B;AACA,iFAAiF;AACjF;IACI,kCAAkC;IAClC,yBAAyB;IACzB,+BAA+B;IAC/B,+CAA+C;IAC/C,2BAA2B;IAC3B,oBAAoB;IACpB,oBAAoB;IACpB,2BAA2B;IAC3B,2BAA2B;IAC3B,wBAAwB;IACxB,2BAA2B;AAC/B","sourcesContent":["/* The markdown editor renders visible text beneath a transparent typing layer. */\n.signup-spouse-editor.w-md-editor {\n    color-scheme: light;\n    --color-fg-default: #111827;\n    --color-canvas-default: #ffffff;\n    --md-editor-background-color: #ffffff;\n    color: #111827;\n    background-color: #ffffff;\n}\n.signup-spouse-editor.w-md-editor .w-md-editor-text-pre,\n.signup-spouse-editor.w-md-editor .w-md-editor-text-pre > code {\n    color: #111827 !important;\n}\n/* Override branded form textarea styling without covering the text underneath. */\n.signup-spouse-editor.w-md-editor textarea.w-md-editor-text-input {\n    background: transparent !important;\n    color: #111827 !important;\n    caret-color: #111827 !important;\n    -webkit-text-fill-color: transparent !important;\n    padding: inherit !important;\n    margin: 0 !important;\n    border: 0 !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    min-height: 0 !important;\n    max-height: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
